import React, { useState, useEffect } from 'react';
import api from '../services/api';

function TimeOffDebug() {
  const [allEntries, setAllEntries] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(null);

  useEffect(() => {
    fetchAllEntries();
  }, []);

  const fetchAllEntries = async () => {
    try {
      setLoading(true);
      const response = await api.get('/timeoff/entries');
      setAllEntries(response.data);
      console.log('ALL ENTRIES:', response.data);
    } catch (err) {
      setError(err.message);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmEntry = async (entryId) => {
    if (!window.confirm('Change this entry status to CONFIRMED?')) return;
    
    try {
      setUpdating(entryId);
      await api.put(`/timeoff/entries/${entryId}`, {
        status: 'confirmed'
      });
      alert('Entry updated to CONFIRMED! Refreshing...');
      await fetchAllEntries();
    } catch (err) {
      alert('Error updating entry: ' + err.message);
    } finally {
      setUpdating(null);
    }
  };

  const handleDeleteEntry = async (entryId) => {
    if (!window.confirm('DELETE this entry permanently?')) return;
    
    try {
      setUpdating(entryId);
      await api.delete(`/timeoff/entries/${entryId}`);
      alert('Entry deleted! Refreshing...');
      await fetchAllEntries();
    } catch (err) {
      alert('Error deleting entry: ' + err.message);
    } finally {
      setUpdating(null);
    }
  };

  if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;
  if (error) return <div style={{ padding: '20px', color: 'red' }}>Error: {error}</div>;

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Time Off Debug - ALL Entries</h1>
      <p><strong>Total entries:</strong> {allEntries?.length || 0}</p>
      
      <table border="1" cellPadding="10" style={{ borderCollapse: 'collapse', width: '100%', marginTop: '20px' }}>
        <thead>
          <tr style={{ background: '#f0f0f0' }}>
            <th>ID</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Days</th>
            <th>Type</th>
            <th>Status</th>
            <th>Notes</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {allEntries && allEntries.length > 0 ? (
            allEntries.map(entry => (
              <tr key={entry.id}>
                <td>{entry.id}</td>
                <td>{entry.start_date}</td>
                <td>{entry.end_date}</td>
                <td>{entry.days_count}</td>
                <td style={{ background: entry.leave_type_color, padding: '5px' }}>
                  {entry.leave_type_name}
                </td>
                <td>
                  <span style={{ 
                    padding: '3px 8px', 
                    borderRadius: '3px',
                    background: entry.status === 'confirmed' ? '#d4edda' : 
                               entry.status === 'planned' ? '#fff3cd' : 
                               entry.status === 'cancelled' ? '#f8d7da' : '#e7e7e7'
                  }}>
                    {entry.status}
                  </span>
                </td>
                <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {entry.notes || '-'}
                </td>
                <td>{new Date(entry.created_at).toLocaleDateString()}</td>
                <td>
                  {entry.status === 'planned' && (
                    <button 
                      onClick={() => handleConfirmEntry(entry.id)}
                      disabled={updating === entry.id}
                      style={{ 
                        padding: '5px 10px', 
                        marginRight: '5px',
                        background: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: updating === entry.id ? 'wait' : 'pointer'
                      }}
                    >
                      {updating === entry.id ? 'Updating...' : 'Confirm'}
                    </button>
                  )}
                  <button 
                    onClick={() => handleDeleteEntry(entry.id)}
                    disabled={updating === entry.id}
                    style={{ 
                      padding: '5px 10px',
                      background: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '3px',
                      cursor: updating === entry.id ? 'wait' : 'pointer'
                    }}
                  >
                    {updating === entry.id ? 'Deleting...' : 'Delete'}
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>
                No entries found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {allEntries && allEntries.length > 0 && (
        <div style={{ marginTop: '30px' }}>
          <h2>November Entries Specifically:</h2>
          {allEntries
            .filter(e => {
              const start = new Date(e.start_date);
              const end = new Date(e.end_date);
              return start.getMonth() === 10 || end.getMonth() === 10; // November = month 10
            })
            .map(entry => (
              <div key={entry.id} style={{ 
                border: '2px solid red', 
                padding: '10px', 
                margin: '10px 0',
                background: '#ffe6e6'
              }}>
                <strong>ID {entry.id}:</strong> {entry.start_date} to {entry.end_date} 
                <br/>Status: <strong>{entry.status}</strong> | Days: {entry.days_count}
                <br/>Notes: {entry.notes || 'none'}
                {entry.status === 'planned' && (
                  <div style={{ marginTop: '10px' }}>
                    <button 
                      onClick={() => handleConfirmEntry(entry.id)}
                      disabled={updating === entry.id}
                      style={{ 
                        padding: '8px 15px',
                        marginRight: '10px',
                        background: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: updating === entry.id ? 'wait' : 'pointer',
                        fontSize: '14px'
                      }}
                    >
                      {updating === entry.id ? 'Updating...' : '✓ Confirm This Entry'}
                    </button>
                    <button 
                      onClick={() => handleDeleteEntry(entry.id)}
                      disabled={updating === entry.id}
                      style={{ 
                        padding: '8px 15px',
                        background: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: updating === entry.id ? 'wait' : 'pointer',
                        fontSize: '14px'
                      }}
                    >
                      {updating === entry.id ? 'Deleting...' : '✗ Delete This Entry'}
                    </button>
                  </div>
                )}
              </div>
            ))
          }
          {allEntries.filter(e => {
            const start = new Date(e.start_date);
            const end = new Date(e.end_date);
            return start.getMonth() === 10 || end.getMonth() === 10;
          }).length === 0 && (
            <p style={{ color: 'red', fontWeight: 'bold' }}>
              NO ENTRIES FOUND FOR NOVEMBER
            </p>
          )}
        </div>
      )}

      <div style={{ marginTop: '30px', padding: '15px', background: '#f8f9fa', borderRadius: '5px' }}>
        <h3>Raw JSON:</h3>
        <pre style={{ 
          background: 'white', 
          padding: '15px', 
          borderRadius: '3px',
          overflow: 'auto',
          maxHeight: '400px'
        }}>
          {JSON.stringify(allEntries, null, 2)}
        </pre>
      </div>
    </div>
  );
}

export default TimeOffDebug;
